import React__default from 'react';
import { Tag } from './Tag.mjs';

const TagList = ({ tags })=>{
    return /*#__PURE__*/ React__default.createElement("ul", {
        style: {
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8
        }
    }, tags.map((tag)=>/*#__PURE__*/ React__default.createElement("li", {
            key: tag
        }, /*#__PURE__*/ React__default.createElement(Tag, {
            size: "small"
        }, tag))));
};

export { TagList };
//# sourceMappingURL=TagList.mjs.map
